<template>
  <g>
    <ellipse :cx="cx" :cy="cy" :rx="rx" :ry="ry"></ellipse>
    <svg-badge :x="lx" :y="ly" variant="primary" :scale="scale">${{ annotation.label }}</svg-badge>
  </g>
</template>

<script>
  import { AnnotationResource } from '@/api-resources';
  import SvgBadge from './SvgBadge';

  export default {
    name: 'AnnotationEllipse',

    components: {
      SvgBadge,
    },

    props: {
      annotation: AnnotationResource,
      scale: Number,
    },

    computed: {
      rx() {
        return (this.annotation.coordinates[2] - this.annotation.coordinates[0]) / 2;
      },

      ry() {
        return (this.annotation.coordinates[7] - this.annotation.coordinates[5]) / 2;
      },

      cx() {
        return this.annotation.coordinates[4] + this.annotation.originRow;
      },

      cy() {
        return this.annotation.coordinates[1] + this.annotation.originColumn;
      },

      lx() {
        return this.cx;
      },

      ly() {
        return this.cy + this.ry + 10;
      },
    },
  };
</script>
